import _ from "lodash";
import api from "../services/api";
import odataMixin from "@/core/store/mixin/odata";

const res = _.merge({}, odataMixin(api), {
  namespaced: true,
});

export default res;
